import React from 'react';
import styled from 'styled-components';

import LandingContent from '../../components/LandingContent';
import Footer from '../../components/Footer';
import ContentRooms from './components/ContentRooms';
import theme from '../../utils/theme';

// import rock from '../../images/Rooms/caveroom/1.jpg';
// import deluxe from '../../images/Rooms/deluxeroom/1.jpg';
// import executive from '../../images/Rooms/executivesuite/1.jpg';
// import luxury from '../../images/Rooms/luxuryroom/1.jpg';
// import washRoom from '../../images/Rooms/villas/5.jpg';
// import premier1 from '../../images/Rooms/premier.png';
// import jacuzzi from '../../images/Rooms/villas/1.jpg';
//import img1 from '../../images/Rooms/1.jpg';
import img1 from '../../images/Rooms/green/3.jpg';
import img2 from '../../images/Rooms/2.jpg';
import img3 from '../../images/Rooms/3.jpg';
import img4 from '../../images/Rooms/4.jpg';
import img5 from '../../images/Rooms/5.jpg';
import img6 from '../../images/Rooms/6.jpg';
import img7 from '../../images/Rooms/7.JPG';


const Rooms = (props) => {
  return (
    <Container>
      <LandingContent images={[ img1,img2,img3,img4,img5,img6,img7 ]} />
      <ContentRooms {...props} />
      <Footer />
    </Container>
  )
}

export default Rooms;

const Container = styled.div`
  width: 100%;
  color: ${theme.primary};
`;
